<template>
    <div>
        <!-- <base-button @click="openModal()" type="info" class="addIndicatorBtn"
            >Add Indicators</base-button
        > -->
        <router-link to="/logmonitoring/addMonitoringForm"><base-button type="info" class="addIndicatorBtn"
            >Add Indicators</base-button
        ></router-link>
        
        <router-link to="/logmonitoring/indicatorForm" ><base-button
            type="info"
            class="addIndicatorBtn"
            >Indicator Form</base-button
        ></router-link>
        <modal
            class="modal alert"
            v-if="showAlert"
            :show.sync="showAlert"
            headerClasses="justify-content-center"
            >Are you sure to delete this indicator?<br />
            <base-button @click="deleteIndicator()" class="alert__button"
                >Yes</base-button
            >
            <base-button
                @click="showAlert = false"
                type="warning"
                class="alert__button"
                >No</base-button
            ></modal
        >
        <modal
            class="modal"
            v-if="showForm"
            :show.sync="showForm"
            headerClasses="justify-content-center"
        >
            <h3 v-if="!isUpdate">Add Indicator</h3>
            <h3 v-if="isUpdate">Update Indicator</h3>
            <el-form
                ref="form"
                :model="form"
                label-width="120px"
                v-if="showForm"
                class="form"
            >
                <div class="input">
                    Grant ID :
                    <el-select
                        v-model="form.Grant_ID"
                        placeholder="Select Indicator Type"
                        class="select__field"
                    >
                        <el-option
                            v-for="item in grantsList"
                            :key="item.id"
                            :label="item.description"
                            :value="item.grantId"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="input">
                    ISO3 :
                    <el-input
                        v-model="form.ISO3"
                        placeholder="Indicator ID"
                        class="input__field"
                    ></el-input>
                </div>

                <div class="select">
                    Region :
                    <el-select
                        v-model="form.Region"
                        placeholder="Select Indicator Type"
                        class="select__field"
                    >
                        <el-option
                            v-for="item in regionsList"
                            :key="item.id"
                            :label="item.type"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </div>
            </el-form>
            <base-button @click="addIndicator()" v-if="!isUpdate"
                >Submit</base-button
            >
            <base-button @click="updateIndicator()" v-if="isUpdate"
                >Update</base-button
            >
        </modal>
        <el-table :data="tableData" style="width: 100%" class="table">
            <el-table-column
                prop="indicatorId"
                label="Indicator ID"
                class="table__column"
                sortable
            >
            </el-table-column>
            <el-table-column
                prop="indicator"
                label="Indicator Name"
                class="table__column"
                sortable
            >
            </el-table-column>
            <el-table-column
                prop="type"
                label="Indicator Type"
                class="table__column"
                sortable
            >
            </el-table-column>
            <el-table-column label="" class="table__column">
                <template slot-scope="scope">
                    <!-- <i
                    class="el-icon-edit"
                        @click="handleEdit(scope.$index, scope.row)"
                        style="color:blue;font-size:larger;"
                        ></i> -->
                    <base-button
                        size="sm"
                        type="info"
                        @click="handleEdit(scope.$index, scope.row)"
                        class="table__button"
                        >Edit<i class="el-icon-edit"></i
                    ></base-button>
                    <base-button
                        size="sm"
                        type="warning"
                        @click="handleDelete(scope.$index, scope.row)"
                        class="table__button"
                        >Delete<i class="el-icon-delete"></i
                    ></base-button>
                </template>
            </el-table-column>
            <!-- <el-pagination layout="prev, pager, next" :total="this.tableData.length" @current-change="setPage">
  </el-pagination> -->
        </el-table>
    </div>
</template>
<style scoped lang="scss">
.table {
    margin-top: 10px;
    &__button {
        margin: 20px !important;
    }
    &__column {
        text-align: center !important;
    }
}
.addIndicatorBtn {
    transform: translateY(-3px);
}
.alert {
    min-height: 25vh;
    color: rgba(34, 42, 66, 0.7);
    padding: 30px;
    &__button {
        margin: 10px;
        margin-left: auto;
    }
}

.form {
    //     display: grid;
    // grid-template-columns: repeat(3, 1fr);
    // grid-template-rows: repeat(3, 1fr);
    // grid-column-gap: 0px;
    // grid-row-gap: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    // gap:5;
    .input {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;

        &__field {
            // max-width: 500px;
            max-width: 30vw;
        }
    }
    .select {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;
        &__field {
            max-width: 30vw;
            border-color: 1px solid;
        }
    }
}
// .btn:not(:disabled):not(.disabled) {
//     margin: 10px;
// }
</style>
<script>
import { LogMonitoringService, GrantService } from "@/services";
import { Table, TableColumn, Select, Option } from "element-ui";
import { Modal } from "src/components";
export default {
    name: "indicator-form",
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        // Pagination
    },
    data() {
        return {
            showForm: false,
            showAlert: false,
            deleteID: "",
            isUpdate: false,
            tableData: [],
            page: 1,
            indicatorTypes: [],
            grantsList: [],
            regionsList: [],
            form: {
                Grant_ID: "",
                // ISO3(or country long name):"",
                ISO3: "",
                Region: "",
                Indicator_ID: "",
                Indicator_name: "",
                Baseline_value: "",
                Baseline_metric: "",
                Final_value: "",
                Final_metric: "",
            },
        };
    },
    methods: {
        setPage(val) {
            this.page = val;
        },
        onSubmit() {
            console.log("submit!");
        },
        openModal() {
            // this.getGrants();
            this.form.indicator_id = "";
            this.form.indicator_name = "";
            this.showForm = !this.showForm;
            this.isUpdate = false;
        },
        // async getIndicators() {
        //     await LogMonitoringService.getIndicators().then((response) => {
        //         this.tableData = response.data.data;
        //         console.log(this.tableData);
        //     });
        // },
        // async getIndicatorTypes() {
        //     await LogMonitoringService.getIndicatortypes().then((response) => {
        //         this.indicatorTypes = response.data.data;
        //         console.log(this.indicatorTypes);
        //     });
        // },
        // async addIndicator() {
        //     if (
        //         this.form.indicator_id == "" ||
        //         this.form.indicator_name == ""
        //     ) {
        //         console.log("No data");
        //         return;
        //     }
        //     const data = {
        //         indicator_id: this.form.indicator_id,
        //         indicator: this.form.indicator_name,
        //         indicator_type_id: this.form.indicator_type,
        //     };
        //     await LogMonitoringService.addIndicator(data).then((response) => {
        //         console.log(response);
        //         this.form.indicator_id = "";
        //         this.form.indicator_name = "";
        //         this.showForm = false;
        //         this.getIndicators();
        //         console.log("Added indicator");
        //     });
        // },
        // async updateIndicator() {
        //     if (
        //         this.form.indicator_id == "" ||
        //         this.form.indicator_name == ""
        //     ) {
        //         console.log("No data");
        //         return;
        //     }
        //     const data = {
        //         id: this.form.id,
        //         indicator_id: this.form.indicator_id,
        //         indicator: this.form.indicator_name,
        //         indicator_type_id: this.form.indicator_type,
        //     };
        //     await LogMonitoringService.updateIndicator(data).then(
        //         (response) => {
        //             console.log(response);
        //             this.form.indicator_id = "";
        //             this.form.indicator_name = "";
        //             this.form.indicator_type = "";
        //             this.showForm = false;
        //             this.isUpdate = false;
        //             this.getIndicators();
        //             console.log("Updated indicator");
        //         }
        //     );
        // },
        // async handleEdit(index, row) {
        //     console.log("Index : ", index);
        //     console.log("Row : ", row.id);
        //     await LogMonitoringService.getIndicator(row.id).then((response) => {
        //         this.getIndicators();
        //         console.log(response);
        //         this.form.id = response.data.data.id;
        //         this.form.indicator_id = response.data.data.indicatorId;
        //         this.form.indicator_name = response.data.data.indicator;
        //         this.form.indicator_type = response.data.data.type;
        //         this.isUpdate = true;
        //         this.showForm = true;
        //     });
        // },
        // async handleDelete(index, row) {
        //     this.deleteID = row.id;
        //     this.showAlert = true;
        // },
        // async deleteIndicator() {
        //     await LogMonitoringService.deleteIndicator({
        //         id: this.deleteID,
        //     }).then((response) => {
        //         console.log(response);
        //         this.showAlert = false;
        //         this.getIndicators();
        //     });
        // },
        async getGrants() {
            await GrantService.all().then((response) => {
                // console.log(response);
                this.grantsList = response.data;
                // console.log("GrantList : ",this.grantsList);
            });
            await GrantService.getGrantRegions().then((response) => {
                console.log(response);
                // this.regionsList = response.data.data;
                // console.log("GrantList : ",this.grantsList);
            });
        },
    },
    mounted() {
        this.getGrants();
        // this.getIndicatorTypes();
    },
    watch: {
        grantsList: function (val) {
            console.log(val);
        },
    },
};
</script>
